export const BASE_URL = (() => {
  try {
    return new URL(process.env.NEXT_PUBLIC_API_BASE_URL || '').origin;
  } catch {
    return '';
  }
})();

export const OBJECT_STORAGE_URL =
  'https://suppr-wilddatapublic-1320403996.cos.ap-shanghai.myqcloud.com';

export const OPENAPI_URL =
  'https://openapi.suppr.wilddata.cn/introduction.html';

export const MCP_URL = 'https://github.com/WildDataX/suppr-mcp';
